function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import { useRef as T, useState as b } from "react";
import { disposables as m } from '../utils/disposables.js';
import { once as E } from '../utils/once.js';
import { useDisposables as S } from './use-disposables.js';
import { useFlags as g } from './use-flags.js';
import { useIsoMorphicEffect as L } from './use-iso-morphic-effect.js';
var y = function (a) {
  return a[a.None = 0] = "None", a[a.Closed = 1] = "Closed", a[a.Enter = 2] = "Enter", a[a.Leave = 4] = "Leave", a;
}(y || {});
function j(e) {
  var i = {};
  for (var t in e) e[t] === !0 && (i["data-".concat(t)] = "");
  return i;
}
function x(e, i, t, r) {
  var _b = b(t),
    _b2 = _slicedToArray(_b, 2),
    a = _b2[0],
    u = _b2[1],
    _g = g(e && a ? 3 : 0),
    d = _g.hasFlag,
    f = _g.addFlag,
    o = _g.removeFlag,
    s = T(!1),
    n = T(!1),
    l = S();
  return L(function () {
    var c;
    if (e) {
      if (t && u(!0), !i) {
        t && f(3);
        return;
      }
      return (c = r == null ? void 0 : r.start) == null || c.call(r, t), C(i, {
        inFlight: s,
        prepare: function prepare() {
          n.current ? n.current = !1 : n.current = s.current, s.current = !0, !n.current && (t ? (f(3), o(4)) : (f(4), o(2)));
        },
        run: function run() {
          n.current ? t ? (o(3), f(4)) : (o(4), f(3)) : t ? o(1) : f(1);
        },
        done: function done() {
          var p;
          n.current && typeof i.getAnimations == "function" && i.getAnimations().length > 0 || (s.current = !1, o(7), t || u(!1), (p = r == null ? void 0 : r.end) == null || p.call(r, t));
        }
      });
    }
  }, [e, t, i, l]), e ? [a, {
    closed: d(1),
    enter: d(2),
    leave: d(4),
    transition: d(2) || d(4)
  }] : [t, {
    closed: void 0,
    enter: void 0,
    leave: void 0,
    transition: void 0
  }];
}
function C(e, _ref) {
  var i = _ref.prepare,
    t = _ref.run,
    r = _ref.done,
    a = _ref.inFlight;
  var u = m();
  return M(e, {
    prepare: i,
    inFlight: a
  }), u.nextFrame(function () {
    u.add(D(e, r)), t();
  }), u.dispose;
}
function D(e, i) {
  var t = E(i),
    r = m();
  if (!e) return r.dispose;
  var _getComputedStyle = getComputedStyle(e),
    a = _getComputedStyle.transitionDuration,
    u = _getComputedStyle.transitionDelay,
    _map = [a, u].map(function (s) {
      var _s$split$filter$map$s = s.split(",").filter(Boolean).map(function (l) {
          return l.includes("ms") ? parseFloat(l) : parseFloat(l) * 1e3;
        }).sort(function (l, c) {
          return c - l;
        }),
        _s$split$filter$map$s2 = _slicedToArray(_s$split$filter$map$s, 1),
        _s$split$filter$map$s3 = _s$split$filter$map$s2[0],
        n = _s$split$filter$map$s3 === void 0 ? 0 : _s$split$filter$map$s3;
      return n;
    }),
    _map2 = _slicedToArray(_map, 2),
    d = _map2[0],
    f = _map2[1],
    o = d + f;
  if (o !== 0) {
    var s = r.group(function (n) {
      var l = n.setTimeout(function () {
        t(), n.dispose();
      }, o);
      n.addEventListener(e, "transitionrun", function (c) {
        c.target === c.currentTarget && (l(), n.addEventListener(e, "transitioncancel", function (p) {
          p.target === p.currentTarget && (t(), s());
        }));
      });
    });
    r.addEventListener(e, "transitionend", function (n) {
      n.target === n.currentTarget && (t(), r.dispose());
    });
  } else t();
  return r.dispose;
}
function M(e, _ref2) {
  var i = _ref2.inFlight,
    t = _ref2.prepare;
  if (i != null && i.current) {
    t();
    return;
  }
  var r = e.style.transition;
  e.style.transition = "none", t(), e.offsetHeight, e.style.transition = r;
}
export { j as transitionDataAttributes, x as useTransition };